import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import type { QueryClient } from "@tanstack/react-query";

import {
	deleteIdbValue,
	reactQueryIdbStore,
	readIdbValue,
	writeIdbValue,
} from "@/lib/shared/storage/idb";

const REACT_QUERY_PERSIST_KEY_PREFIX = "clutch:react-query";

export function getReactQueryPersistKey(userId?: string | null) {
	return `${REACT_QUERY_PERSIST_KEY_PREFIX}:${userId ?? "guest"}`;
}

const indexedDbAsyncStorage = {
	getItem: async (key: string) => {
		return await readIdbValue<string>(key, reactQueryIdbStore);
	},
	setItem: async (key: string, value: string) => {
		await writeIdbValue(key, value, reactQueryIdbStore);
	},
	removeItem: async (key: string) => {
		await deleteIdbValue(key, reactQueryIdbStore);
	},
};

export function createReactQueryPersister(userId?: string | null) {
	return createAsyncStoragePersister({
		storage: indexedDbAsyncStorage,
		key: getReactQueryPersistKey(userId),
		throttleTime: 1_000,
	});
}

export async function clearPersistedReactQueryCache(
	queryClient?: QueryClient,
	userId?: string | null,
) {
	queryClient?.clear();
	await deleteIdbValue(getReactQueryPersistKey(userId), reactQueryIdbStore);
}
